module.exports = __webpack_public_path__ + "assets/img/icon_user20.6ef5681c.png";